import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="f-left">© 2026 lakeshore LLC — Los Angeles, CA</div>
      <div className="f-right">
        <Link to="/thesis">Thesis</Link>
        <Link to="/portfolio">Portfolio</Link>
        <Link to="/team">Team</Link>
        <Link to="/contact">Contact</Link>
      </div>
    </footer>
  );
}
